// @flow
import { call, put, select, takeEvery } from 'redux-saga/effects'
import { ORGANIZATION_SETTINGS } from '../actionTypes'
import { organizationSettings, setPendingGet } from '../actions'
import { showError } from '../../toastr/utils'
import { getOrganizationSettingsPendingGet } from '../selectors'
import makeAPIRequest from 'store/entities/api/sagas'
import { ORGANIZATION_SETTINGS as ORGANIZATION_SETTINGS_ENDPOINT } from 'app/constants/api/organizationSettings'

// TODO: Serginyo90 looks like this never use
export default function* getSaga(): Generator<*, *, *> {
  yield takeEvery(ORGANIZATION_SETTINGS.GET.REQUEST, handleGetRequest)
}

export function* handleGetRequest(): Generator<*, *, *> {
  try {
    const pending = yield select(getOrganizationSettingsPendingGet)
    if (!pending) {
      yield put(setPendingGet(true))
      const {
        data: { data },
      } = yield call(makeAPIRequest, ORGANIZATION_SETTINGS_ENDPOINT, {
        method: 'GET',
      })
      yield put(organizationSettings.get.success(data))
    }
  } catch (error) {
    console.error('organizationSettings handleGetRequest saga failed', error)
    yield put(organizationSettings.get.fail(error))
    showError()
  } finally {
    yield put(setPendingGet(false))
  }
}
